import { IUnsubscribeGroup } from '../../types/unsubscribeGroups/unsubscribeGroups.types';
import {
  CreateUnsubscribePreferencePayload,
  UpdateUnsubscribePreferencePayload,
} from '../../services/unsubscribePreferenceService/unsubscribePreferenceService';

export const GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST =
  'GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST';
export const GET_PUBLIC_UNSUBSCRIBE_GROUPS_SUCCESS =
  'GET_PUBLIC_UNSUBSCRIBE_GROUPS_SUCCESS';
export const GET_PUBLIC_UNSUBSCRIBE_GROUPS_FAILURE =
  'GET_PUBLIC_UNSUBSCRIBE_GROUPS_FAILURE';

export const CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST =
  'CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST';
export const CREATE_UNSUBSCRIBE_PREFERENCE_SUCCESS =
  'CREATE_UNSUBSCRIBE_PREFERENCE_SUCCESS';
export const CREATE_UNSUBSCRIBE_PREFERENCE_FAILURE =
  'CREATE_UNSUBSCRIBE_PREFERENCE_FAILURE';

export const UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST =
  'UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST';
export const UPDATE_UNSUBSCRIBE_PREFERENCE_SUCCESS =
  'UPDATE_UNSUBSCRIBE_PREFERENCE_SUCCESS';
export const UPDATE_UNSUBSCRIBE_PREFERENCE_FAILURE =
  'UPDATE_UNSUBSCRIBE_PREFERENCE_FAILURE';

export const GET_UNSUBSCRIBE_PREFERENCE_REQUEST =
  'GET_UNSUBSCRIBE_PREFERENCE_REQUEST';
export const GET_UNSUBSCRIBE_PREFERENCE_SUCCESS =
  'GET_UNSUBSCRIBE_PREFERENCE_SUCCESS';
export const GET_UNSUBSCRIBE_PREFERENCE_FAILURE =
  'GET_UNSUBSCRIBE_PREFERENCE_FAILURE';

export const CLEAR_UNSUBSCRIBE_PREFERENCES = 'CLEAR_UNSUBSCRIBE_PREFERENCES';
export const CLEAR_UNSUBSCRIBE_PREFERENCE_STATUS =
  'CLEAR_UNSUBSCRIBE_PREFERENCE_STATUS';

export interface GetPublicUnsubscribeGroupsRequestAction {
  type: typeof GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST;
  payload: {
    trackingId: string;
  };
  [key: string]: any;
}

export interface GetPublicUnsubscribeGroupsSuccessAction {
  type: typeof GET_PUBLIC_UNSUBSCRIBE_GROUPS_SUCCESS;
  payload: IUnsubscribeGroup[];
  [key: string]: any;
}

export interface GetPublicUnsubscribeGroupsFailureAction {
  type: typeof GET_PUBLIC_UNSUBSCRIBE_GROUPS_FAILURE;
  payload: {
    error: string;
  };
  [key: string]: any;
}

export interface CreateUnsubscribePreferenceRequestAction {
  type: typeof CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST;
  payload: {
    trackingId: string;
    data: CreateUnsubscribePreferencePayload;
  };
  [key: string]: any;
}

export interface CreateUnsubscribePreferenceSuccessAction {
  type: typeof CREATE_UNSUBSCRIBE_PREFERENCE_SUCCESS;
  payload: any;
  [key: string]: any;
}

export interface CreateUnsubscribePreferenceFailureAction {
  type: typeof CREATE_UNSUBSCRIBE_PREFERENCE_FAILURE;
  payload: {
    error: string;
  };
  [key: string]: any;
}

export interface UpdateUnsubscribePreferenceRequestAction {
  type: typeof UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST;
  payload: {
    trackingId: string;
    data: UpdateUnsubscribePreferencePayload;
  };
  [key: string]: any;
}

export interface UpdateUnsubscribePreferenceSuccessAction {
  type: typeof UPDATE_UNSUBSCRIBE_PREFERENCE_SUCCESS;
  payload: any;
  [key: string]: any;
}

export interface UpdateUnsubscribePreferenceFailureAction {
  type: typeof UPDATE_UNSUBSCRIBE_PREFERENCE_FAILURE;
  payload: {
    error: string;
  };
  [key: string]: any;
}

export interface ClearUnsubscribePreferencesAction {
  type: typeof CLEAR_UNSUBSCRIBE_PREFERENCES;
  [key: string]: any;
}

export interface GetUnsubscribePreferenceRequestAction {
  type: typeof GET_UNSUBSCRIBE_PREFERENCE_REQUEST;
  payload: {
    trackingId: string;
  };
  [key: string]: any;
}

export interface GetUnsubscribePreferenceSuccessAction {
  type: typeof GET_UNSUBSCRIBE_PREFERENCE_SUCCESS;
  payload: any;
  [key: string]: any;
}

export interface GetUnsubscribePreferenceFailureAction {
  type: typeof GET_UNSUBSCRIBE_PREFERENCE_FAILURE;
  payload: {
    error: string;
  };
  [key: string]: any;
}

export interface ClearUnsubscribePreferenceStatusAction {
  type: typeof CLEAR_UNSUBSCRIBE_PREFERENCE_STATUS;
  [key: string]: any;
}

export type UnsubscribePreferenceActionTypes =
  | GetPublicUnsubscribeGroupsRequestAction
  | GetPublicUnsubscribeGroupsSuccessAction
  | GetPublicUnsubscribeGroupsFailureAction
  | GetUnsubscribePreferenceRequestAction
  | GetUnsubscribePreferenceSuccessAction
  | GetUnsubscribePreferenceFailureAction
  | CreateUnsubscribePreferenceRequestAction
  | CreateUnsubscribePreferenceSuccessAction
  | CreateUnsubscribePreferenceFailureAction
  | UpdateUnsubscribePreferenceRequestAction
  | UpdateUnsubscribePreferenceSuccessAction
  | UpdateUnsubscribePreferenceFailureAction
  | ClearUnsubscribePreferencesAction
  | ClearUnsubscribePreferenceStatusAction;
